import Image from 'next/image';

import { extractImageName } from '../logic';
import * as PS from '../style';
import type { JustImageDiv } from '../type';
import * as S from './style';

export default function JustImageDivFrame({ div }: { div: JustImageDiv }) {
  function handleClickImage() {
    if (!div || (!div.imgLinkUrl && !div.imgClickLogTitle)) {
      return;
    }

    if (div.imgLinkUrl) {
      window.open(div.imgLinkUrl, div.isNewTab ? '_blank' : '_self');
    }
  }

  return (
    <PS.DivWrapper
      id={div.tagId}
      bgColor={div.bgColor}
      onClick={handleClickImage}
      isClickable={!!div.imgLinkUrl}
    >
      <S.MobileImageWrapper>
        <Image
          src={div.mobileImageUrl}
          alt={extractImageName(div.mobileImageUrl)}
          layout='fill'
          objectFit='cover'
          objectPosition='top'
        />
      </S.MobileImageWrapper>
      <S.DesktopImageWrapper>
        <Image
          src={div.desktopImageUrl}
          alt={extractImageName(div.desktopImageUrl)}
          layout='fill'
          objectFit='cover'
          objectPosition='top'
        />
      </S.DesktopImageWrapper>
    </PS.DivWrapper>
  );
}
